/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Reason_PromptInputs */

const en_us2_swap_reason_prompt = /** @type {(inputs: Swap_Reason_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why swap? (optional)`)
};

const pt_br2_swap_reason_prompt = /** @type {(inputs: Swap_Reason_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que trocar? (opcional)`)
};

const es_419_swap_reason_prompt = /** @type {(inputs: Swap_Reason_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué cambiar? (opcional)`)
};

const pt_pt2_swap_reason_prompt = /** @type {(inputs: Swap_Reason_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê trocar? (opcional)`)
};

const fr_fr2_swap_reason_prompt = /** @type {(inputs: Swap_Reason_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi changer ? (facultatif)`)
};

const de_de2_swap_reason_prompt = /** @type {(inputs: Swap_Reason_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum tauschen? (optional)`)
};

const it_it2_swap_reason_prompt = /** @type {(inputs: Swap_Reason_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché cambiare? (facoltativo)`)
};

/**
* | output |
* | --- |
* | "Why swap? (optional)" |
*
* @param {Swap_Reason_PromptInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_reason_prompt = /** @type {((inputs?: Swap_Reason_PromptInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Reason_PromptInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_reason_prompt(inputs)
	if (locale === "es-419") return es_419_swap_reason_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_reason_prompt(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_reason_prompt(inputs)
	if (locale === "de-DE") return de_de2_swap_reason_prompt(inputs)
	if (locale === "it-IT") return it_it2_swap_reason_prompt(inputs)
	return en_us2_swap_reason_prompt(inputs)
});
export { swap_reason_prompt as "swap.reason_prompt" }